<div ngForm layout-gt-md="row" layout-wrap="false" role="group">
	<div uiControl>
		<table [ngClass]="styles.durationContainer">
			<tr>
				<td *ngIf="this.maxDays">
					<span [ngClass]="styles.durationLabel">{{'Days' | translate}}</span>
				</td>
				<td>
					<span [ngClass]="styles.durationLabel">{{'Hours' | translate}}</span>
				</td>
				<td>
					<span [ngClass]="styles.durationLabel">{{'Minutes' | translate}}</span>
				</td>
			</tr>
			<tr>
				<td *ngIf="this.maxDays">
					<div class="btn-group" dropdown [isDisabled]="disabled">
						<button type="button" [id]="'daysButton' + durationInputIndex" dropdownToggle class="btn dropdown-toggle">
							{{internalModel.days}} <span class="caret"></span>
						</button>
						<ul [id]="'daysDropdown' + durationInputIndex" class="dropdown-menu" *dropdownMenu role="menu" [attr.aria-labelledby]="'daysButton' + durationInputIndex">
							<li role="menuitem" *ngFor="let i of days">
								<button type="button" class="dropdown-item" (click)="setModelDays(i)">
									{{ i }}
								</button>
							</li>
						</ul>
					</div>
				</td>
				<td>
					<div class="btn-group" dropdown [isDisabled]="maxDaysSelected || disabled">
						<button type="button" [id]="'hoursButton' + durationInputIndex" dropdownToggle class="btn dropdown-toggle">
							{{internalModel.hours}} <span class="caret"></span>
						</button>
						<ul [id]="'hoursDropdown' + durationInputIndex" class="dropdown-menu" *dropdownMenu [ngClass]="styles.scrollableContainer" role="menu" [attr.aria-labelledby]="'hoursButton' + durationInputIndex">
							<li role="menuitem" *ngFor="let i of hours">
								<button type="button" class="dropdown-item" (click)="setModelHours(i)">
									{{ i }}
								</button>
							</li>
						</ul>
					</div>
				</td>
				<td>
					<div class="btn-group" dropdown [isDisabled]="maxDaysSelected || maxHoursSelected || disabled">
						<button type="button" [id]="'minsButton' + durationInputIndex" dropdownToggle class="btn dropdown-toggle">
							{{internalModel.minutes}} <span class="caret"></span>
						</button>
						<ul [id]="'minsDropdown' + durationInputIndex" *dropdownMenu class="dropdown-menu" [ngClass]="styles.scrollableContainer" role="menu" [attr.aria-labelledby]="'minsButton' + durationInputIndex">
							<li role="menuitem" *ngFor="let i of minutes">
								<button type="button" class="dropdown-item" (click)="setModelMinutes(i)">
									{{ i }}
								</button>
							</li>
						</ul>
					</div>
				</td>
			</tr>
		</table>
	</div>
</div>
